import { Component, effect, input, signal } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { Store } from '@ngrx/store';
import { NgScrollbar } from 'ngx-scrollbar';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProjectSpendService } from '../../../../../../services/project-spend.service';
import { InteractionBarStateService } from '../../../../../../services/interaction-bar-state.service';
import { viewProjectActions } from '../../../../../../store/view-project/view-project.actions';
import { PROJECT_VIEWS } from '../../../../../../framework/constants/view-project.constants';
import { SELECTED_OPTION } from '../../../../../../framework/overlays/option-list.constants';
import { MoneyPipe } from '../../../../../../pipes/framework/money-short.pipe';
import { SpendCustomInputComponent } from '../../../../../../framework/inputs/spend-custom-input/spend-custom-input.component';
import { FloatingInputComponent } from '../../../../../../framework/inputs/floating-input/floating-input.component';
import { SimpleButtonComponent } from '../../../../../../framework/buttons/simple-medium-button/simple-button.component';
import { SPEND_TYPES } from '../../../../../../framework/constants/spend.constants';
import { BudgetAdjustment, BudgetHistoryData } from './project-budget-history.types';

const leaveAnimationTiming = 500;

@Component({
  selector: 'app-project-budget-history',
  templateUrl: './project-budget-history.component.html',
  styleUrls: ['./project-budget-history.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(100vw)', opacity: 0 }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate(
          `${leaveAnimationTiming}ms ease-in-out`,
          style({ transform: 'translateX(100vw)', opacity: 0 }),
        ),
      ]),
    ]),
  ],
  imports: [
    SimpleButtonComponent,
    NgClass,
    NgScrollbar,
    NgTemplateOutlet,
    FloatingInputComponent,
    SpendCustomInputComponent,
    MoneyPipe,
    FormsModule,
  ],
})
export class ProjectBudgetHistoryComponent {
  protected readonly SPEND_TYPES = SPEND_TYPES;
  protected readonly SELECTED_OPTION = SELECTED_OPTION;
  protected readonly Math = Math;

  projectId = input.required<number>();
  isLoading = signal(true);
  sortedAdjustments = signal<BudgetAdjustment[]>([]);
  lineItems = signal<BudgetHistoryData[]>([]); // formatted to be shown on table
  dates = signal<string[]>([]);

  totals = signal<{
    original_budget: number;
    current_budget: number;
    adjustments: any[];
  }>({ original_budget: 0, current_budget: 0, adjustments: [] });

  constructor(
    private projectSpendService: ProjectSpendService,
    private interactionBar: InteractionBarStateService,
    private store: Store,
  ) {
    effect(() => {
      if (!this.projectId()) return;
      this.loadData();
    });
  }

  loadData() {
    this.isLoading.set(true);
    this.projectSpendService.getBudgetAdjustments(this.projectId()).subscribe((data) => {
      this.sortedAdjustments.set(data.sortedAdjustments);
      this.lineItems.set(data.lineItems);
      this.dates.set(data.dates);
      this.totals.set(data.totals);
      this.isLoading.set(false);
    });
  }

  closeView() {
    this.store.dispatch(viewProjectActions.viewChanged({ view: PROJECT_VIEWS.DEFAULT }));
  }

  openBudgetLog() {
    this.interactionBar.openBudgetAdjustmentLog(this.sortedAdjustments());
  }
}
